module.exports = __webpack_public_path__ + "img/banner.ecdce6e2.jpg";